import { getActiveAccountId } from '@/api/authVault';
import { resetChatRuntimeForLogout } from '@/store/chatStore';
import { useUIStore } from '@/store/uiStore';
import { useUserStore } from '@/store/userStore';

const WALLPAPER_META_KEY_PREFIX = 'askyourai_wallpaper';
const WALLPAPER_IMG_KEY_PREFIX = 'askyourai_wallpaper_img';
const LEGACY_WALLPAPER_META_KEY = 'askyourai_wallpaper';
const LEGACY_WALLPAPER_IMG_KEY = 'askyourai_wallpaper_img';
const WIDGET_STORAGE_KEY_PREFIX = 'askyourai_widget_canvas';
const WIDGET_SCOPED_KEYS = [
  'askyourai:widget:calendar-modal',
  'askyourai:widget:email-modal',
  'askyourai:widget:dm-modal',
  'askyourai:widget:agent-modal',
  'askyourai:widget:layout-meta',
] as const;

function removeLocalStorageKey(key: string): void {
  try {
    window.localStorage.removeItem(key);
  } catch {
    // storage access errors are non-fatal during auth reset
  }
}

function getScopedStorageKey(baseKey: string, accountId: string | null): string {
  return `${baseKey}:${accountId || 'anonymous'}`;
}

export function resetRuntimeSessionState(options?: {
  resetDarkMode?: boolean;
}): void {
  useUserStore.getState().clear();
  resetChatRuntimeForLogout();

  if (options?.resetDarkMode) {
    useUIStore.getState().setDarkMode(true);
  }

  useUIStore.setState({
    wallpaper: null,
    wallpaperUpdatedAt: 0,
    wallpaperAccountId: null,
    wallpaperExplicit: false,
    settingsModalOpen: false,
    settingsModalRequest: null,
  });
}

export function clearWithdrawnAccountClientState(accountId: string | null = getActiveAccountId()): void {
  removeLocalStorageKey(getScopedStorageKey(WIDGET_STORAGE_KEY_PREFIX, accountId));
  WIDGET_SCOPED_KEYS.forEach((key) => {
    removeLocalStorageKey(getScopedStorageKey(key, accountId));
  });

  removeLocalStorageKey(getScopedStorageKey(WALLPAPER_META_KEY_PREFIX, accountId));
  removeLocalStorageKey(getScopedStorageKey(WALLPAPER_IMG_KEY_PREFIX, accountId));
  removeLocalStorageKey(LEGACY_WALLPAPER_META_KEY);
  removeLocalStorageKey(LEGACY_WALLPAPER_IMG_KEY);

  if (useUIStore.getState().wallpaperAccountId === accountId) {
    useUIStore.setState({
      wallpaper: null,
      wallpaperUpdatedAt: 0,
      wallpaperAccountId: null,
      wallpaperExplicit: false,
    });
  }
}
